const FakeSelect = {
  el: {
    root: document.querySelectorAll<HTMLElement>('.fake-select'),
  },

  init(): void {
    Array.prototype.forEach.call(this.el.root, (item: HTMLElement) => {
      item.querySelector('.fake-select__trigger').addEventListener('click', (e: Event & { target: HTMLElement }) => {
        const itm = <HTMLElement>e.target.parentNode
        itm.classList.toggle('open')
      })
    })
  },
}

export default FakeSelect
